const ActiveStatementMsgConfig = {
  CREDIT_CARD: 'checkout.lib.components.paymentResult.detail.activeStatement.cc',
  ECP: 'checkout.lib.components.paymentResult.detail.activeStatement.ecp',
  EUDD: 'checkout.lib.components.paymentResult.detail.activeStatement.eudd',
  CREDIT_BALANCE: undefined,
  APPLEPAY: 'checkout.lib.components.paymentResult.detail.activeStatement.cc',
  GOOGLEPAY: 'checkout.lib.components.paymentResult.detail.activeStatement.cc',
};

export default ActiveStatementMsgConfig;
